const mapSelectors = function() {
  const selectors = {};

  const getDisplayType = function(owner) {
    const map = {
      client: 'public',
      global: 'global',
      user: 'private',
    };

    return map[owner];
  };

  const getType = function(entity) {
    if (entity.clientId) {
      if (entity.userId) {
        return 'user';
      }
      if (entity.editable) {
        return 'client';
      }
      return 'global';
    }
  };

  const getLists = function(state) {
    return state.map.mapSets.idsByOwner;
  };

  const getEntities = function(state) {
    return state.map.mapSets.byId;
  };

  const getListByType = function(state, type) {
    if (getLists(state).hasOwnProperty(type)) {
      return getLists(state)[type];
    }

    return null;
  };

  selectors.getSelectedMapSetId = function(state) {
    return state.map.mapSets.selectedId;
  };

  selectors.getBasemaps = function(state) {
    return state.map.basemaps;
  };

  selectors.getMapSet = function(state, id) {
    const mapSet = getEntities(state)[id];

    if (!mapSet) {
      return null;
    }

    return Object.assign({}, mapSet, {
      type: getDisplayType(getType(mapSet)),
    });
  };


  selectors.getMapSetsByType = function(state, type) {
    if (typeof (type) !== 'string') {
      console.error('Type must be a string'); /* eslint no-console: 0 */
      return null;
    }

    const list = getListByType(state, type);

    if (list) {
      return list.reduce((acc, curr) => {
        const mapSet = selectors.getMapSet(state, curr);

        acc.push(mapSet);

        return acc;
      }, []);
    }

    return [];
  };


  selectors.getMapSetsByTypes = function(state, types) {
    return types.reduce((acc, curr) => acc.concat(selectors.getMapSetsByType(state, curr)), []);
  };

  return selectors;
};

export default mapSelectors();
